import ima2 from "../assets/agent.jpg";

const CTASection = () => {
  return (
    <section
      className="relative py-32 bg-fixed bg-cover bg-center text-white"
      style={{ backgroundImage: `url(${ima2})` }}
    >
      <div className="bg-black/60 bg-[#313896]/70 absolute inset-0"></div>
      <div className="relative container flex-col mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold font-serif">
          Your IP Isn't Training Data.
        </h2>
        <p className="mt-4 text-lg md:text-xl text-[#00d7ff]/80">
          Our platform works for you - not for big tech. Secure, intelligent,
          and hallucination-free by design.
        </p>
        <div className="mt-6">
          <button
            className="bg-[#9f32b2] px-8 py-3 text-lg font-medium rounded-md hover:bg-[#9f32b2]/90 transition duration-300"
            onClick={() =>
              document
                .getElementById("contact")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Get Started for Free
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
